// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__vsl9j","header":"Accordion_header__He70g","bottomBorder":"Accordion_bottomBorder__ixrZz","content":"Accordion_content__4BwW5"};